import * as React from "react";
import { forwardRef } from "react";
const SvgRun = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 15, height: 16, viewBox: "0 0 15 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M1.5 8.00004V5.33004C1.5 2.01504 3.8475 0.657544 6.72 2.31504L9.0375 3.65004L11.355 4.98504C14.2275 6.64254 14.2275 9.35754 11.355 11.015L9.0375 12.35L6.72 13.685C3.8475 15.3425 1.5 13.985 1.5 10.67V8.00004Z", stroke: "white", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgRun);
export default ForwardRef;
